import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/Layout"
import Metas from "../components/Metas"
import Pagination from "../components/Pagination"
import PublicationListItem from "../components/ListItems/PublicationListItem"
import Title from "../components/Title"
import { cssCleanClass } from "../Utils/functions"
import CustomBreadcrumb from "../components/CustomBreadcrumb"

const TypesPublicationList = ({ pageContext, data, location }) => {
  const {
    breadcrumb: { crumbs },
    currentPage,
    numPages,
    basePath,
  } = pageContext

  return (
    <Layout>
      <Metas title={pageContext.name} />
      <section className="section page-breadcrumb is-small has-background-light">
        <div className="container">
          <CustomBreadcrumb crumbs={crumbs} />
        </div>
      </section>

      <section className="section page-content">
        <div className="container">
          <Title title="Publications" className="has-text-centered" />

          {pageContext.types && (
            <div className="publication-types has-text-centered">
              <h2 className="title is-6 is-uppercase">Filtrer par type</h2>
              <div className="tags is-centered">
                {pageContext.types.map((type, index) =>
                  parseInt(pageContext.tid, 10) === parseInt(type.id, 10) ? (
                    <span
                      key={index}
                      className="tag is-rounded theme theme-darkgreen no-scale"
                    >
                      <Link to={`/publications`}>{type.name}</Link>
                    </span>
                  ) : (
                    <span
                      key={index}
                      className="tag is-rounded theme theme-green"
                    >
                      <Link to={`/publications${type.path}`}>{type.name}</Link>
                    </span>
                  )
                )}
              </div>
            </div>
          )}

          <div className="columns is-multiline">
            {data.publications.nodes.map((node, index) => (
              <div key={index} className="column is-6 is-4-desktop publication">
                <PublicationListItem content={node} />
              </div>
            ))}
          </div>

          <Pagination
            path={location.pathname}
            currentPage={currentPage}
            numPages={numPages}
            basePath={basePath}
          />
        </div>
      </section>
    </Layout>
  )
}

export default TypesPublicationList

export const query = graphql`
  query publicationTagsListQuery($tid: Int!, $skip: Int!, $limit: Int!) {
    publications: allNodePublication(
      filter: {
        status: { eq: true }
        relationships: {
          field_publication_type: { drupal_internal__tid: { eq: $tid } }
        }
      }
      sort: { fields: created, order: DESC }
      limit: $limit
      skip: $skip
    ) {
      nodes {
        title
        relationships {
          image: field_image {
            localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 335
                  height: 473
                  quality: 100
                  transformOptions: { cropFocus: CENTER }
                  layout: CONSTRAINED
                )
              }
            }
          }
          file: field_fichier {
            localFile {
              publicURL
              prettySize
            }
          }
        }
      }
    }
  }
`
